import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import LightBox from '@bd/bdui-lightbox';
import { Image } from '@bd/bdcore-utilities';
import { BtnAnimationSheen } from '../../helpers/UIElements';

import AccordionToggle from '../../components/AccordionToggle';
import icons from '../../components/IconsList';

const styles = css`
  @media(min-width: 992px) {
    padding: 50px 20px;
  }
  .FloorplanPhotos_image {
    cursor: pointer;
  }
  .ImagesList_btn {
    width: 200px;
    &:focus {
      outline: none;
    }
  }
  .DetailSection_heading {
    border-top: 1px solid #E3E3E3;
    @media(min-width: 992px) {
      border-top: 0;
    }
  }
  .ImagesList_overlay {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 144, 210, 0.85);
    width: 100%;
    height: 100%;
    display: none;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all .3s ease-out;
    &::after {
      content: '';
      background-image: url(${get(icons, 'expendWhite')});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 26px;
      height: 26px;
      @media(min-width: 992px) {
        width: 45px;
        height: 45px;
      }
    }
  }
  .PlanPhotos_img {
    &:hover {
      .ImagesList_overlay {
        display: flex;
      }
    }
  }
`;

class ImagesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: props.increment,
    };
  }
  loadMoreImages = () => {
    this.setState({ limit: this.state.limit + this.props.increment });
  }
  render() {
    const { limit } = this.state;
    const { list, title, elevations } = this.props;
    return (
      <div className={styles}>
        <AccordionToggle
          openOnId="floorplans"
          button={({ contentVisible }) => (
            <div className="">
              <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>{title}</h3>
            </div>
          )}
        >
          <div className="container">
            <div className="d-flex flex-wrap justify-content-center">
              {
                list.slice(0, limit).map(item => (
                  <LightBox
                    items={list}
                    className={`PlanPhotos_img ${elevations ? 'col-6 col-lg-4 px-0' : 'col-10 col-lg-6 mb-5'}`}
                    key={item.contentUrl}
                    button={(
                      <div className="position-relative">
                        <Image
                          src={get(item, 'contentUrl')}
                          alt={get(item, 'caption', '')}
                          width={2000}
                          height={2000}
                          className=" img-fluid FloorplanPhotos_image"
                        />
                        <span className="ImagesList_overlay" />
                      </div>
                    )}
                  />
                ))
              }
            </div>
            {
              list.length > limit &&
              <div className="d-flex justify-content-center mt-4">
                <BtnAnimationSheen role="button" tabIndex={0} onClick={this.loadMoreImages} className="Btn_default ImagesList_btn">Load More</BtnAnimationSheen>
              </div>
            }
          </div>
        </AccordionToggle>
      </div>
    );
  }
}

ImagesList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  increment: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  elevations: PropTypes.bool,
};

ImagesList.defaultProps = {
  elevations: false,
};

export default ImagesList;



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/ImagesList.js